module.exports = __webpack_public_path__ + "static/media/background.c1e2e104.jpg";